<template>
  <div class="headerPar">
  <el-row>
    <el-col :span="10">
      <img class="logo" mode="heightFix" src="../assets/logo-techik.jpg" alt />
    </el-col>
    <el-col :span="10" :offset="4" align="right">
      <el-button v-if="hasNav" @click="changeCollapse">折叠菜单</el-button>
      <el-button v-else @click="changeCollapse">打开菜单</el-button>
      <el-dropdown trigger="click" @command="dropdown">
        <p class="el-dropdown-link">
          <i class="el-icon-s-tools"></i>
          <span class="userName">{{user_name}}</span>
        </p>
        <el-dropdown-menu slot="dropdown" class="logOut">
          <el-dropdown-item command="updateEmailOrPwd">修改邮箱密码</el-dropdown-item>
          <el-dropdown-item command="logout">退出</el-dropdown-item>
          <!-- <el-dropdown-item command="changePwd">更改密码</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
    </el-col>
  </el-row>

  <el-dialog
    @close="closeDialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="500px"
  >
    <el-form  :model="updateForm" :rules="rules" ref="updateForm">
          <el-form-item label="邮箱" prop="email" >
            <el-input v-model.trim="updateForm.email"></el-input>
          </el-form-item>

          <el-form-item label="新密码" prop="password" >
            <el-input type="password" v-model.trim="updateForm.password"></el-input>
          </el-form-item>

          <el-form-item label="再次输入" prop="password" >
            <el-input type="password" v-model.trim="password"></el-input>
          </el-form-item>


    </el-form>
    <template #footer>
      <el-button type="primary" size="mini" @click="updateEmailOrPwd">提交</el-button>
      <el-button type="primary" size="mini" @click="closeDialog">取消</el-button>
    </template>
  </el-dialog>

    <!--  <div class="header" ref="header">
       <div class="left">
       </div>
       <div class="right">
       </div>
     </div>
     <el-dialog
       @close="closeDialog"
       :close-on-click-modal="false"
       :visible.sync="dialogVisible"
       width="500px"
     >
       <Add :changeMode="true" :isAdd="false" :isEdit="false" :edit_id="user_id" :departmentList="{}" />
     </el-dialog>-->
  </div>

</template>
<script>
import { mapGetters } from "vuex";
import Navigator from "@/components/navigator";
import Add from "@/views/system/user/add";
import commonPRAS from "../common/constant";
export default {
  name: "Header",
  data() {
    return {
      user_name: "哈哈",
      dialogVisible: false,
      password:'',
      updateForm:{
        email:'',
        password:''
      },
      rules: {
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" },
          {trigger: "blur",validator:(rule, value, callback) => {
              if (this.password&&this.updateForm.password&&this.password===this.updateForm.password) {
                return callback();
              } else {
                return callback(new Error("两次密码不一致"));
              }
            }}],
      }
    };
  },
  components: {
    Navigator,
    Add
  },
  computed: {
    ...mapGetters(["user_id", "hasNav"])
  },
  mounted() {
    // console.log(this.hasNav)
    this.user_name = localStorage.getItem("username");
  },
  methods: {
    changeCollapse() {
      if (this.hasNav) {
        this.$store.dispatch("updateHasNav", false);
      } else {
        this.$store.dispatch("updateHasNav", true);
      }
    },
    dropdown(command) {
      // console.log(command);
      if (command == "changePwd") {
        this.dialogVisible = true;
      } else if (command == "logout") {
        this.logout();
      }else if(command=="updateEmailOrPwd"){
        this.opendialog()
      }
    },
    logout() {
      var that = this;
      this.$confirm("确定要退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await this.$router.push("/login");
          // await that.ajaxLog();
          const key = process.env.NODE_ENV+"_"+commonPRAS.tag;
          localStorage.removeItem(key+"_"+"accessToken");
          localStorage.removeItem(key+"_"+"refreshToken");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    ajaxLog() {
      var that = this;
      that.$axios
        .get("/techik/user/logout", {
          headers: { Authorization: `Bearer ${localStorage.getItem(process.env.NODE_ENV+"_"+commonPRAS.tag+"_"+"accessToken")}` }
        })
        .then(res => {
          that.$message({
            type: "success",
            message: "退出成功!"
          });
        })
        .catch(error => {
          // getFailure(that);
        });
    },
    closeDialog() {
      this.updateForm={}
      this.password=""
      this.dialogVisible = false;
    },
    opendialog(){
      this.dialogVisible=true
    },
    updateEmailOrPwd(){
      const that =this
      this.$refs["updateForm"].validate(valid=>{
        if(valid&&localStorage.getItem(process.env.NODE_ENV+"_"+commonPRAS.tag+"_"+"accessToken")){
          that.$axios
            .post("/techik/user/updatePersonal", that.updateForm,{
              headers: { Authorization: `Bearer ${localStorage.getItem(process.env.NODE_ENV+"_"+commonPRAS.tag+"_"+"accessToken")}` }
            })
            .then(res => {
              const {code ,message,data} = res.data
              if(code==1){
                that.$message({
                  type: "success",
                  message: "修改成功，需重新登陆!"
                });
                const key = process.env.NODE_ENV+"_"+commonPRAS.tag;
                localStorage.removeItem(key+"_"+"accessToken");
                localStorage.removeItem(key+"_"+"refreshToken");
                this.$router.push("/login")
              }else{
                that.$message({
                  type: "info",
                  message: message
                });
              }
            })
            .catch(error => {
              // getFailure(that);
            });
        }
      })
    }
  }
};
</script>
<style scoped>
.headerPar {
  width: 100%;
}

.el-row {
  height: 60px;
  line-height: 60px;
  box-shadow: 0 0px 6px 0px rgb(75 124 183 / 43%);
}

.logo {
  height: 60px;
  width: auto;
  margin-left: 5px;
  float: left;
}

.el-dropdown {
  font-size: 22px;
  margin-right: 20px;
}

.header {
  width: 100%;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 0px 6px 0px rgb(75 124 183 / 43%);
}

i.iconfont {
  font-size: 20px;
  margin-right: 4px;
  color: #000;
}
.left {
  width: 100%;
  height: 100%;
}

.right {
  width: 100%;
  text-align: right;
}

.right .fl {
  margin: 4px;
}
.userName {
  font-size: 15px;
  font-weight: 600;
}
/* .logOut {
  width: 70px;
} */
</style>



// WEBPACK FOOTER //
// src/components/header.vue